import { useState } from 'react';

import { useNavParams } from 'hooks';

import { queries } from 'RestAPIs/rapini';

import { DataGrid } from 'components/shared';

import AddProjectDrawer from './AddProjectDrawer/AddProjectDrawer';
import useProjectsGrid from './useProjectsGrid';

export default function Projects() {
  const [drawerOpen, setDrawerOpen] = useState(false);
  const { setParams } = useNavParams();

  const { data: projects } = queries.useGetProjects(undefined, undefined);
  const { columns, rows } = useProjectsGrid(projects);

  function onAddClick() {
    setDrawerOpen(true);
  }

  function onViewClick(id) {
    setParams({ projectId: id });
  }

  return (
    <DataGrid
      columns={columns}
      rows={rows}
      onAddClick={onAddClick}
      onViewClick={onViewClick}
      initialState={{
        sorting: {
          sortModel: [{ field: 'name', sort: 'asc' }]
        }
      }}
      addRowDialog={
        <AddProjectDrawer
          open={drawerOpen}
          handleClose={() => setDrawerOpen(false)}
        />
      }
    />
  );
}
